/* 公共页面 */
<template>
  <div class="iframe-view">
    <iframe
      width="100%"
      :id="id"
      frameborder="0"
      :height="dynaHeight"
      :src="src"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: ["hashCode"],
  name: 'commonIframe',
  data() {
    return {
      userName: '',
      custom: {},
      dynaHeight: document.documentElement.clientHeight - 105,
    };
  },
  computed: {
    id() {
      return Math.random();
    },
    src() {
      if(this.hashCode) {
        return `/openPage/index.html#/${this.hashCode}`
      }else{
        if (this.custom.data) {
          var urlParams = "";
          for (var k in this.custom.data) {
            if (urlParams) {
              urlParams += "&";
            }
            if (typeof this.custom.data[k] == "object") {
              urlParams += k + "=" + encodeURIComponent(this.custom.data[k] == null ? '' : JSON.stringify(this.custom.data[k]));
            } else {
              urlParams += k + "=" + encodeURIComponent(this.custom.data[k] == null ? '' : this.custom.data[k]);
            }
          }
          urlParams += "&userName=" + this.userName;
          return this.custom.path + "?" + urlParams;
        } else {
          return this.custom.path + "?userName=" + this.userName;
        }
      }
    }
  },
  mounted() {
    window.addEventListener('message', this.msgFunc, false);
    if(window.sessionStorage.getItem(this.$route.fullPath)){
      this.custom = JSON.parse(window.sessionStorage.getItem(this.$route.fullPath));
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.msgFunc)
  },
  methods: {
    msgFunc(e) {
      if(e.data.type == "openPage"){
        this.$emit("page", e.data);
      }else if(e.data.type == 'removePage'){
        this.$emit("removePage", e.data);
      }
    },
  },
};
</script>

<style lang="less" scoped>
</style>